/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dashboardsList } from "../funcs/dashboardsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDashboardsResult } from "../models/components/listdashboardsresult.js";
import {
  ListDashboardsRequest,
  ListDashboardsSecurity,
} from "../models/operations/listdashboards.js";
import { unwrapAsync } from "../types/fp.js";
export type DashboardsQueryData = ListDashboardsResult;

export function prefetchDashboards(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDashboardsRequest | undefined,
  security?: ListDashboardsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDashboardsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDashboardsQuery(
  client$: GramCore,
  request?: ListDashboardsRequest | undefined,
  security?: ListDashboardsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<DashboardsQueryData>;
} {
  return {
    queryKey: queryKeyDashboards({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function dashboardsQueryFn(
      ctx,
    ): Promise<DashboardsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(dashboardsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDashboards(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "dashboards", "list", parameters];
}
